var stickyInnerHeader = (function () {


    var setUpStickyInnerHeader = function () {
        // Add sticky header on scroll
        $(window).scroll(function() {
            // var screenHight = $( window ).height();
            var scroll = $(window).scrollTop();
            var element = $('.c-inner-header__wrapper');
            var topSectionHeight = $('.c-inner-header__wrapper .c-live-return-wrapper').innerHeight();

            // Add pinned header class for changing styling
            if (scroll >= topSectionHeight ) {
                element.addClass("pinned-inner-header");
            } else {
                element.removeClass("pinned-inner-header");
            }

            // show pinned kpi
            if (scroll >= 100 ) {
                element.addClass("pinned-inner-kpi");
            } else {
                element.removeClass("pinned-inner-kpi");
            }
        });
    };
  
    var init = function () {
      setUpStickyInnerHeader();
    };
  
    return {
      init: init
    };
  })();
  
  export default stickyInnerHeader;


// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/stickyInnerHeader.js